import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Currency } from '@/components/atoms/Currency'

import { StakedRpkForXpMultiplierItem } from '@/services/account'

interface XPMultiplierListProps {
  multipliers: StakedRpkForXpMultiplierItem[]
}

export const XPMultiplierList: FC<XPMultiplierListProps> = ({
  multipliers,
}) => {
  const { t } = useTranslation('common')

  if (!multipliers) return null

  return (
    <div className="w-full flex flex-col bg-cool-gray-800 bg-opacity-30 rounded-lg px-9 py-6">
      <div className="flex flex-row gap-[10%] justify-between text-cool-gray-200 text-xs sm:text-base font-normal mb-4">
        <span className="flex flex-1 border-b border-cool-gray-600 pb-1">
          {t('XPWallet.xpMultiplierList.xpRewardMultiplier')}
        </span>
        <span className="flex flex-1 border-b border-cool-gray-600 pb-1">
          {t('XPWallet.xpMultiplierList.staked')}
        </span>
      </div>
      {multipliers && (
        <div className="text-white font-bold">
          {multipliers?.map((multiplier) => (
            <div
              key={multiplier.xpMultiplier}
              className="flex flex-row gap-[10%] justify-between items-baseline mb-5"
            >
              <span className="flex flex-1 text-2xl sm:text-3xl">
                {multiplier.xpMultiplier}%
              </span>
              <span className="flex flex-1 text-sm sm:text-lg">
                <Currency value={multiplier.staked} />
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
